function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Pointer = function Pointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "m4.175 14.154 4.277 5.458c.531.609 1.11 1.042 1.685 1.247.37.132.803.12 1.307.113l.42-.006 1.454.002q1.45.002 2.9-.002c.837-.002 1.09-.017 1.44-.301.438-.354.831-.878 1.138-1.516.241-.501.368-.954.368-1.311V13.14c0-1.052-1.195-1.614-1.907-1.855L11.57 9.36a1 1 0 0 1-.679-.947V3.446c0-.121-.03-.285-.17-.376-.143-.091-.41-.094-.82-.01-.379.079-.665.299-.807.62a1.4 1.4 0 0 0-.122.517v9.376c0 .395-.233.753-.593.914a1.01 1.01 0 0 1-1.077-.172l-1.836-1.658c-.345-.158-.72-.104-1.112.162-.595.404-.288 1.122-.179 1.335m6.896 8.823c-.503 0-1.047-.035-1.605-.233-.904-.322-1.764-.948-2.556-1.86l-4.36-5.561a1 1 0 0 1-.079-.117c-.505-.876-.996-2.847.757-4.04 1.061-.721 2.266-.798 3.308-.205a1 1 0 0 1 .177.127l.26.234V4.197c0-.43.1-.887.29-1.321.405-.92 1.22-1.565 2.233-1.774.604-.123 1.501-.23 2.305.285.693.446 1.09 1.196 1.09 2.059v4.25l5.007 1.694c2.076.702 3.266 2.07 3.266 3.75v4.698c0 .665-.19 1.398-.566 2.178-.434.904-1.016 1.665-1.682 2.203-.915.74-1.77.744-2.598.748-1.063.003-2.033 0-3.003 0h-1.45l-.38.004q-.202.005-.414.006"
  }));
};
export default Pointer;